// extracted by mini-css-extract-plugin
export var breadcrumb = "_2-2";
export var breadcrumbArrow = "_2-3";
export var breadcrumbs = "_2-0";
export var link = "_2-4";
export var small = "_2-1";